export const roundNumber = (n: number, fractionDigits: number) => {
	return parseFloat(n.toFixed(fractionDigits));
};
